module.exports = __webpack_public_path__ + "static/media/yt.91e20003.svg";